/* eslint-disable no-underscore-dangle */
import { BaseSlideAppService } from '../../../core/services/slide-app-service.base';
import { LocalEditEvents } from '../core/interfaces/local-edit-events.interface';
import { LocalEditServices } from '../core/local-edit-services.core';
import { DocumentStatus } from '@tencent/slide-sdk-model/src/manager/content-status-manager';

/**
 * 本地文档 3.0
 */
export class LocalSlideAppService extends BaseSlideAppService {
    private declare chunks?: {
        total: number,
        done: boolean,
    };

    public getSlideCount() {
        if (!this.chunks || this.chunks?.done) {
            return super.getSlideCount();
        }

        return this.chunks.total;
    }

    protected init() {
        this.subscribeContentStatus();
    }


    private async subscribeContentStatus() {
        const contentStatus = this.contentStatusManager;
        const emitter = await LocalEditServices.LocalEditEvents.promise();
        const err = this.checkSlideAppStatus();
        if (err) {
            emitter.emit(LocalEditEvents.SlideAppDataError, err);
        } else {
            emitter.emit(LocalEditEvents.SlideAppInitSuccess);
        }

        contentStatus.onDocumentStatusChange((status) => {
            switch (status) {
                case DocumentStatus.Corrupted:
                    emitter.emit(LocalEditEvents.SlideAppDataError, contentStatus.getCorruptedError() ?? new Error(''));
                    break;
                case DocumentStatus.Modified:
                    emitter.emit(LocalEditEvents.DocumentChanged);
            }
        });
    }
}
